import { useEffect, useState } from "react";

// Desain HP (kanvas "HoonStore Desain HP", Gaya B): hanya di layar < 768 px (batas `md` Tailwind yang dipakai halaman lain).
// Layar komputer tetap memakai tampilan lama.
const KUERI = "(max-width: 767px)";

const cocok = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(KUERI).matches;

export function useHp() {
  const [hp, setHp] = useState(cocok);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const m = window.matchMedia(KUERI);
    const ubah = () => setHp(m.matches);
    ubah();
    m.addEventListener ? m.addEventListener("change", ubah) : m.addListener(ubah);
    return () => { m.removeEventListener ? m.removeEventListener("change", ubah) : m.removeListener(ubah); };
  }, []);
  return hp;
}
